import { create } from 'zustand'
interface BackgroundState {
    background: string;
    changeBackround: (value: string) => void;
}
export const useBackground = create<BackgroundState>((set) => ({
    background: '#fff',
    changeBackround: (background: string) => set(() => ({ background }))
}))
